import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";



function FaqForm() {
  const { id } = useParams(); // id for edit, undefined for new
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const [categoryId, setCategoryId] = useState("");
  const [categories, setCategories] = useState([]);
  const [published, setPublished] = useState(true);

  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  useEffect(() => {
    // Fetch categories
    axios.get(process.env.REACT_APP_API_URL +"/faq-categories", {
      headers: { Authorization: `Bearer ${token}` },
    }).then(res => setCategories(res.data));

    // If editing, fetch FAQ
    if (id) {
      axios.get(`${process.env.REACT_APP_API_URL}/admin/faqs/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      }).then(res => {
        const faq = res.data;
        setQuestion(faq.question);
        setAnswer(faq.answer);
        setCategoryId(faq.category_id);
        setPublished(faq.published);
      });
    }
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = { question, answer, category_id: categoryId, published };

    try {
      if (id) {
        await axios.put(`${process.env.REACT_APP_API_URL}/faqs/${id}`, data, {
          headers: { Authorization: `Bearer ${token}` },
        });
      } else {
        await axios.post(process.env.REACT_APP_API_URL +"/faqs", data, {
          headers: { Authorization: `Bearer ${token}` },
        });
      }
      navigate("/admin/faqs");
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="container py-5">
      <h2 className="mb-4">{id ? "Edit FAQ" : "Add New FAQ"}</h2>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label>Question</label>
          <input type="text" className="form-control" value={question} onChange={e => setQuestion(e.target.value)} required />
        </div>
        <div className="mb-3">
          <label>Answer</label>
          <textarea className="form-control" rows="5" value={answer} onChange={e => setAnswer(e.target.value)} required />
        </div>
        <div className="mb-3">
          <label>Category</label>
          <select className="form-control" value={categoryId} onChange={e => setCategoryId(e.target.value)} required>
            <option value="">Select Category</option>
            {categories.map(cat => (
              <option key={cat.id} value={cat.id}>{cat.name}</option>
            ))}
          </select>
        </div>
        <div className="mb-3 form-check">
          <input type="checkbox" className="form-check-input" checked={published} onChange={e => setPublished(e.target.checked)} />
          <label className="form-check-label">Published</label>
        </div>
        <button type="submit" className="btn btn-primary">{id ? "Update FAQ" : "Add FAQ"}</button>
      </form>
    </div>
  );
}

export default FaqForm;
